import { Store } from "pullstate";


export const VideoStore = new Store({
   video:null
  });

